import { alertError } from './alert';
import { getSupplierRetailers } from './api/suppliers';
import {
  APPROVED_RETAILERS,
  APPROVED_RETAILERS_COUNT,
  APPROVED_RETAILERS_OFFSET,
  APPROVED_RETAILERS_LOADING,
} from '../constants/approvedRetailers';
import { getTotalCountHeader } from './api/utils';

const setApprovedRetailersLoading = (value) => ({ type: APPROVED_RETAILERS_LOADING, payload: value });
const setApprovedRetailers = (data) => ({ type: APPROVED_RETAILERS, payload: data });
const setApprovedRetailersCount = (count) => ({ type: APPROVED_RETAILERS_COUNT, payload: count });

export const getApprovedRetailers = () => async (dispatch, getState) => {
  const { perPage, offset, count, isLoading } = getState().approvedRetailers;
  const { field, order } = getState().pageFilters.retailers;
  const { supplierId } = getState().role;
  const { search } = getState().searchAllRetailers;

  if (isLoading) {
    return;
  }

  const filter = {
    $or: [{ approved_for_ecommerce: true }, { approved_for_replenishment: true }],
  };

  if (search && search !== '') {
    filter['retailer.name'] = { $like: `%${search}%` };
  }

  try {
    dispatch(setApprovedRetailersLoading(true));
    const response = await getSupplierRetailers(supplierId, filter, perPage, offset, order, field);
    const newCount = getTotalCountHeader(response);

    if (count !== newCount) {
      dispatch(setApprovedRetailersCount(newCount));
    }
    dispatch(setApprovedRetailers(response.data));
    dispatch(setApprovedRetailersLoading(false));
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const setApprovedRetailersOffset = (offset) => (dispatch) => {
  dispatch({ type: APPROVED_RETAILERS_OFFSET, payload: offset });
  dispatch(getApprovedRetailers());
};
